import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        component_alert_flash_state:{
            prop_alert_show:false,
            prop_alert_modal:false,
            prop_alert_type:"info",
            prop_alert_heading:"loading",
            prop_alert_message:"please wait... "
        },
        data_form_view:{
            username:"",
            form_name:"",
            form_id:""
        },
        data_submissions_summary:null,//is a map but initialize to null for first-load
    },
    getters:{
        component_alert_flash_getstate_all:function(state)
        {
            return state.component_alert_flash_state
        },
        data_form_view_getstate_all:function(state)
        {
            return state.data_form_view
        },
        data_submissions_summary_getstate_all:function(state)
        {
            return state.data_submissions_summary
        },
    },
    mutations: {
        component_alert_flash_mutstate_all:function(state,payload)
        {
            state.component_alert_flash_state.prop_alert_show=payload.show
            state.component_alert_flash_state.prop_alert_modal=payload.modal
            state.component_alert_flash_state.prop_alert_type=payload.type
            state.component_alert_flash_state.prop_alert_heading=payload.heading
            state.component_alert_flash_state.prop_alert_message=payload.message
        },
        data_form_view_mutstate_all:function(state,payload)
        {
            state.data_form_view.username=payload.username
            state.data_form_view.form_name=payload.form_name
            state.data_form_view.form_id=payload.form_id
        },
        data_submissions_summary_mutstate_all:function(state,payload)
        {
            state.data_submissions_summary=payload
        },
    },
    actions: {
        component_alert_flash_action_toggle:function(context,payload)
        {
            return new Promise(
                function(resolve_func,reject_func)
                {
                    context.commit('component_alert_flash_mutstate_all',payload)

                    resolve_func();
                }
            );
        },
        data_form_view_action_set_all:function(context,payload)
        {
            return new Promise(
                function(resolve_func,reject_func)
                {
                    context.commit('data_form_view_mutstate_all',payload)

                    resolve_func();
                }
            );
        },
        data_submissions_summary_action_set_all:function(context,payload)
        {
            return new Promise(
                function(resolve_func,reject_func)
                {
                    context.commit('data_submissions_summary_mutstate_all',payload)

                    resolve_func();
                }
            );
        }
    },
    modules: {
    }
})
